module.exports = __webpack_public_path__ + "img/icone_busca.936f1489.svg";